module.exports = __webpack_public_path__ + "static/media/colorful-night.579b49bc.png";